import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DatosPersonalesRequest } from 'src/app/global/interfaces/datos-personales-request';
import { DatosPersonalesProvider } from 'src/app/global/providers/services/datos-personales/datos-personales.provider';
import { DatosPersonalesService } from 'src/app/view-model/services/datos-personales.service';


@Injectable()
export class DatosPersonalesVM extends DatosPersonalesService {

  constructor(private datosPersonalesProv: DatosPersonalesProvider) {
    super();
  }

  obtenerDatosPersonales(): Observable<any> {
    return this.datosPersonalesProv.getDatosPersonales().pipe(
      map(this.obtieneDatosOk),
      catchError(this.error)
    );
  }

  private obtieneDatosOk(resp) {
    return resp;
  }

  registraDatosPersonales(datosPersonales: DatosPersonalesRequest): Observable<any> {
    return this.datosPersonalesProv.registraDatosPersonales(datosPersonales).pipe(
      map(this.registraPersonaOk),
      catchError(this.error)
    );
  }

  private registraPersonaOk(resp) {
    return resp;
  }

  obtenerNacionalidades(): Observable<any> {
    return this.datosPersonalesProv.getNacionalidades().pipe(
      map(this.nacionalidadesOk),
      catchError(this.error)
    );
  }

  private nacionalidadesOk(resp) {
    return resp;
  }

  validaEdicion(): Observable<any> {
    return this.datosPersonalesProv.validaEdicion().pipe(
      map(this.validaEdicionOk),
      catchError(this.error)
    );
  }

  private validaEdicionOk(resp) {
    return resp;
  }

  private error(error) {
    return error;
  }

}
